<template>
  <div>
    <!-- 觸發區域 -->
    <div class="picker-trigger form-control" @click="open">
      <span :class="selected.length ? 'picker-value' : 'picker-placeholder'">
        {{ selected.length ? selected.join(' / ') : (placeholder || '請選擇') }}
      </span>
      <span class="picker-arrow">▾</span>
    </div>

    <!-- 底部彈層 -->
    <transition name="slide-up">
      <div v-if="visible" class="picker-overlay" @click.self="close">
        <div class="picker-modal">
          <!-- 頂部操作欄 -->
          <div class="picker-header">
            <span class="picker-back" @click="goBack">‹ 上一級</span>
            <span class="picker-title">請選擇</span>
            <span class="picker-close" @click="close">✕</span>
          </div>
          <!-- 麵包屑路徑 -->
          <div class="picker-crumbs" v-if="tempPath.length">{{ tempPath.join(' > ') }}</div>
          <!-- 列表 -->
          <ul class="picker-list">
            <li
              v-for="(item, i) in currentItems"
              :key="i"
              class="picker-item"
              @click="selectItem(item)"
            >
              {{ item.label }}
              <span v-if="item.children && item.children.length" class="picker-item-arrow">›</span>
            </li>
            <li v-if="currentItems.length === 0" class="picker-empty">已到最後一級，請點確定</li>
          </ul>
          <!-- 確認按鈕 -->
          <div class="picker-actions">
            <el-button type="primary" class="btn btn-info btn-block" @click="confirm">確定</el-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BottomPicker',
  props: {
    options: { type: Array, default: () => [] }, // 已轉換好的 { label, value, children } 樹
    value: { type: Array, default: () => [] },   // 已選路徑（label 數組）
    placeholder: { type: String, default: '請選擇' }
  },
  data () {
    return {
      visible: false,
      tempPath: []  // 臨時選擇路徑（label 數組）
    }
  },
  computed: {
    selected () { return this.value || [] },
    // 根據 tempPath 找到當前層的列表
    currentItems () {
      let node = { children: this.options }
      for (const label of this.tempPath) {
        const found = (node.children || []).find(c => c.label === label)
        if (!found) return []
        node = found
      }
      return node.children || []
    }
  },
  methods: {
    open () {
      this.tempPath = [...(this.value || [])]
      this.visible = true
    },
    close () { this.visible = false },
    goBack () { if (this.tempPath.length > 0) this.tempPath.pop() },
    selectItem (item) {
      this.tempPath.push(item.label)
      // 若無子級則直接確認
      if (!item.children || item.children.length === 0) {
        this.confirm()
      }
    },
    confirm () {
      this.$emit('input', [...this.tempPath])
      this.visible = false
    }
  }
}
</script>

<style scoped>
.picker-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  background: #fff;
  height: 40px;
  padding: 0 15px;
  border: 1px solid #DCDFE6;
}
.picker-placeholder { color: #999; }
.picker-value { color: #333; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.picker-arrow { color: #999; margin-left: 8px; }
.picker-overlay {
  position: fixed;
  z-index: 1000;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: flex-end;
}
.picker-modal {
  width: 100%;
  max-height: 70vh;
  background: #fff;
  border-radius: 12px 12px 0 0;
  display: flex;
  flex-direction: column;
}
.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
}
.picker-back, .picker-close { color: #188AFF; cursor: pointer; min-width: 60px; }
.picker-close { text-align: right; }
.picker-title { font-weight: 600; }
.picker-crumbs {
  padding: 8px 16px;
  background: #f7f7f7;
  color: #666;
  font-size: 13px;
}
.picker-list { flex: 1; overflow-y: auto; list-style: none; padding: 0; margin: 0; }
.picker-item {
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
}
.picker-item:active { background: #f5f5f5; }
.picker-item-arrow { color: #ccc; }
.picker-empty { padding: 14px 16px; color: #999; text-align: center; }
.picker-actions { padding: 12px 16px; border-top: 1px solid #eee; }
.picker-actions /deep/ .btn { 
  width: 100%;
  background: #007AFF;
  border-color: #007AFF;
}
.slide-up-enter-active, .slide-up-leave-active { transition: opacity .2s; }
.slide-up-enter, .slide-up-leave-to { opacity: 0; }
</style>
